import { IntuiBreadcrumb } from '@/components/intueri/IntuiBreadcrumb/IntuiBreadcrumb'
import { Database, FileStack } from 'lucide-react'
import { useTranslation } from '@/i18n'

interface PidSetNavbarProps {
  setName: string
}

export default function PidSetNavbar({ setName }: PidSetNavbarProps) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center justify-between border-b border-border bg-background px-6 py-[18px] shrink-0">
      <IntuiBreadcrumb
        items={[
          {
            label: t('nav:menu.data', 'Data'),
            href: '/data-catalog',
            icon: <Database className="size-[18px]" />,
          },
          {
            label: setName,
            icon: <FileStack className="size-[18px]" />,
          },
        ]}
      />
    </div>
  )
}
